export default {
  GENERAL: 'general',
  SEO: 'seo',
  CUSTOM_CODE: 'custom_code',
};
